import { Component, HostBinding, input } from '@angular/core'

@Component({
	selector: 'corepark-logo',
	templateUrl: './corepark.component.html',
})
export class CoreParkComponent {
	readonly filled = input<boolean>(true)
	readonly colorFill = input<string>('var(--color-black)')
	readonly height = input<string>('6rem')

	@HostBinding('style.display')
	readonly display = 'inline-block'

	@HostBinding('style.width')
	readonly width = 'auto'

	@HostBinding('style.height') get heightStyle(): string {
		return this.height()
	}
}
